import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../../../../../../components/loading/loading";
import { getSubdivisionDetailsRequest } from "../../../../../../../redux/clients/slice";
import { useDispatch } from "react-redux";
import { clientDivisionActivateRequest } from "../../../../../../../utils/APICalls";

const styles = {
  container: {
    width: 500,
    maxWidth: 500,
  },
  headerTxt: {
    fontWeight: "540",
    letterSpacing: "0.6px",
    fontSize: 20,
  },
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  layout: {
    width: 452,
    mt: -2,
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
    mb: 0.5,
  },
  actionBtn: {
    ml: 2,
    mr: 1,
  },
  buttonLayout: {
    mb: 0.5,
  },
  buttonTxt: {
    fontWeight: "510",
    letterSpacing: "0.5px",
    fontSize: 14,
  },
};

export default function DivisionActivate({
  showDialog,
  closeDialog,
  id,
  clientId,
}: any) {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const activateDivsion = async () => {
    setLoading(true);
    const response = await clientDivisionActivateRequest(clientId, id);
    setLoading(false);
    if (response?.status === 204) {
      dispatch(
        getSubdivisionDetailsRequest({ id: clientId, subDivisionId: id })
      );
      closeDialog();
    }
  };

  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: styles.container }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography sx={styles.headerTxt}>Activate Division?</Typography>
      </DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.layout}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.message}>
            Are you sure you want to activate this division?
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.buttonLayout}>
        <Button variant="outlined" onClick={closeDialog}>
          <Typography sx={styles.buttonTxt}>Cancel</Typography>
        </Button>
        <Button
          sx={styles.actionBtn}
          variant="contained"
          onClick={activateDivsion}
          autoFocus
        >
          <Typography sx={styles.buttonTxt}>Activate Division</Typography>
        </Button>
      </DialogActions>
      {loading && <Loading />}
    </Dialog>
  );
}
